import React, {Component} from "react";
import { observer } from "mobx-react";
import SoldOutViewItem from "./sub/SoldOutViewItem";
import {fn_sold_out} from "../../../../function/FnBodyStep";
import {fn_bridge_order_cancel} from "../../../../function/FnPosBridge";

@observer
class SoldOutView extends Component {
    constructor(props) {
        super(props);
        this.state={soldOutScroll:0}
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let soldOutArea = document.getElementById("soldOutLayer")
        soldOutArea.scrollTop=this.state.soldOutScroll;
    }

    scrollSet=(val)=>{
        this.setState({soldOutScroll:val})
    }

    scrollUp=()=>{
        if( this.state.soldOutScroll >= 57)
            this.setState({soldOutScroll:this.state.soldOutScroll - 57})
    }

    scrollDown=()=>{
        if( this.state.soldOutScroll+331 < document.getElementById("soldOutLayer").scrollHeight )
            this.setState({soldOutScroll:this.state.soldOutScroll + 57})
    }

    render() {

        const { rootStore } = this.props;
        const viewStore = rootStore.viewStore;
        const layerStore = rootStore.layerStore;
        const prods = rootStore.viewStore.getOrderSoldOutProd;
        
        return(
            <div className={"layer_comm layer_common_type "+(layerStore.getLayerSoldOutView?' layer_open':'')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            <h1>품절처리</h1>
                        </div>
                        <div className="section_soldout">
                            <h2>품절 처리할 상품를 선택해주세요</h2>
                            <div className="wrap_soldout">
                                <div className="scroll scroll_hidden" id="soldOutLayer">
                                    <ul className="list_soldout">
                                        {
                                            ( Array.isArray(prods) && prods.length )
                                            ?
                                                prods.map((prod)=>(
                                                    prod.prodType==="M"?
                                                        <SoldOutViewItem key={viewStore.getOrderDetail.mobileOrderNo+prod.rowNo} rootStore={rootStore} prod={prod} scrollSet={this.scrollSet}/>
                                                    :null
                                                ))
                                            : null
                                        }
                                    </ul>
                                </div>
                                <div className="btns">
                                    <button type="button" className="btn_up" onClick={this.scrollUp}><span></span></button>
                                    <button type="button" className="btn_down" onClick={this.scrollDown}><span></span></button>
                                </div>
                            </div>
                            <ul className="list_dot">
                                <li>품절 처리 시, 연결메뉴에 동시 적용됩니다.</li>
                                <li>품절 상태를 해제하시려면 [상품 품절 관리]메뉴를 이용해주세요.</li>
                                <li>배민/쿠팡이츠/요기요 이용 시, 각 채널 프로그램에서 별도로 품절처리를 해야 합니
                                    다.
                                </li>
                            </ul>
                            <div className="wrap_full_btn wrap_full_btn2">
                                <span className="f_l"><button className="btn_cancel"
                                    onClick={event=>{
                                        //fn_change_step(rootStore,'900');
                                        fn_bridge_order_cancel(rootStore);
                                        if( viewStore.getOrderDetail.stepCd === "000" ){
                                            rootStore.layerStore.setLayerAlertType("soldout_next");
                                        }else{
                                            rootStore.layerStore.setLayerAlertType("soldout_next_cancel");
                                        }

                                    }}
                                >다음에</button></span>
                                <span className="f_r"><button className="btn_submit"
                                      onClick={event=>{
                                          fn_sold_out(rootStore);
                                          if( viewStore.getOrderDetail.stepCd === "000" ){
                                              rootStore.layerStore.setLayerAlertType("soldout_ok");
                                          }else{
                                              rootStore.layerStore.setLayerAlertType("soldout_cancel_ok");
                                          }
                                      }}
                                >품절처리</button></span>
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => layerStore.setLayerSoldOut(false) }
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SoldOutView;